const admin = {
  accessDenied: {
    title: 'Accès refusé',
    description: 'Cette zone est réservée aux administrateurs.',
  },
  title: 'Tableau de bord administrateur',
  tabs: {
    sessions: 'Sessions',
    traces: 'Traces',
    costSummary: 'Résumé des coûts',
    analytics: 'Analyses',
    feedback: 'Commentaires',
    reports: 'Rapports',
  },
  actions: {
    close: 'Fermer',
    refresh: 'Actualiser',
    refreshData: 'Actualiser les données',
    reset: 'Réinitialiser',
    resetFilters: 'Réinitialiser les filtres',
    resetToDefaults: 'Rétablir les valeurs par défaut',
    previous: 'Précédent',
    next: 'Suivant',
    details: 'Détails',
    view: 'Voir',
    exportCsv: 'Exporter au format CSV',
    exporting: 'Exportation...',
    viewHtml: 'Voir le HTML',
    viewPdf: 'Voir le PDF',
    delete: 'Supprimer',
    deleteReport: 'Supprimer le rapport',
    generateReport: 'Générer un rapport',
    generateNewReport: 'Générer un nouveau rapport',
    cancel: 'Annuler',
    generating: 'Génération...',
    viewTrace: 'Voir la trace',
    copy: 'Copier',
    copied: 'Copié',
    full: 'Complet',
    viewFullData: 'Voir les données complètes',
    viewFullOutput: 'Voir le résultat complet',
  },
  filters: {
    dateRange: 'Plage de dates',
    customRange: 'Plage personnalisée',
    today: "Aujourd'hui",
    lastDays: 'Les {{count}} derniers jours',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    customerId: 'ID client',
    allCustomers: 'Tous les clients',
  },
  errors: {
    label: 'Erreur :',
  },
  status: {
    loading: 'Chargement...',
    loadingData: 'Chargement des données administratives',
    noData: 'Aucune donnée trouvée',
  },
  labels: {
    notAvailable: 'S/O',
  },
  sessions: {
    title: 'Sessions de chat',
    excludeEmpty: 'Exclure les sessions vides',
    userInitiatedOnly: "Sessions initiées par l'utilisateur uniquement",
    total: '{{count}} sessions au total',
    noResults: 'Aucune session ne correspond aux filtres.',
    noSessionsToExport: 'Aucune session à exporter',
    exportFailed: 'Impossible d’exporter les sessions au format CSV',
    exportAll: 'Exporter toutes les sessions au format CSV',
    noMessages: 'Aucun message',
    viewAnalysis: "Voir l'analyse avec le score {{score}}",
    viewLinkClicks: 'Voir {{count}} clics sur les liens',
    headers: {
      user: 'Utilisateur',
      customer: 'Client',
      source: 'Source',
      firstMessage: 'Premier message',
      started: 'Commencée',
      messages: 'Messages',
      analysis: 'Analyse',
      linkClicks: 'Clics sur les liens',
      details: 'Détails',
    },
  },
  traces: {
    title: 'Traces de messages',
    summary: 'Affichage de {{visible}} traces sur {{total}}',
    headers: {
      messageId: 'ID du message',
      traceId: 'ID de trace',
      createdAt: 'Créé le',
      inputTokens: "Jetons d'entrée",
      outputTokens: 'Jetons de sortie',
      time: 'Durée',
      actions: 'Actions',
    },
  },
  costSummary: {
    title: 'Résumé des coûts',
    noData: 'Aucune donnée de coût disponible pour la plage de dates sélectionnée.',
    totalCost: 'Coût total',
    totalTokens: 'Total des jetons',
    inputTokens: "Jetons d'entrée",
    outputTokens: 'Jetons de sortie',
    dailyBreakdown: 'Répartition quotidienne',
    noDailyData: 'Aucune donnée de coût quotidienne disponible pour cette période.',
    headers: {
      date: 'Date',
      messages: 'Messages',
      inputTokens: "Jetons d'entrée",
      outputTokens: 'Jetons de sortie',
      cacheTokens: 'Jetons du cache',
      cost: 'Coût',
    },
  },
  analytics: {
    title: "Analyses de l'utilisation des jetons",
    noData: "Aucune donnée d'analyse disponible pour la plage de dates sélectionnée.",
    dateRange: 'Affichage des données du {{start}} au {{end}}',
    noPeriodData: "Aucune donnée d'analyse disponible pour cette période.",
    headers: {
      date: 'Date',
      messages: 'Messages',
      inputTokens: "Jetons d'entrée",
      outputTokens: 'Jetons de sortie',
      cacheTokens: 'Jetons du cache',
      toolsExecuted: 'Outils exécutés',
      averageResponseTime: 'Temps de réponse moyen',
    },
  },
  feedback: {
    title: 'Commentaires sur les messages',
    total: '{{count}} enregistrements de commentaires au total',
    noResults: 'Aucun commentaire ne correspond aux filtres.',
    noSessionId: "Aucun ID de session n'est disponible pour ce commentaire.",
    sessionLoadFailed: 'Impossible de charger les détails de la session.',
    headers: {
      submitted: 'Envoyé',
      rating: 'Évaluation',
      messagePreview: 'Aperçu du message',
      comments: 'Commentaires',
      customer: 'Client',
      user: 'Utilisateur',
      session: 'Session',
    },
  },
  reports: {
    title: "Rapports d'analyse",
    total: '{{count}} rapports au total',
    deleteConfirmation: 'Voulez-vous vraiment supprimer ce rapport ?',
    deleteFailed: 'Impossible de supprimer le rapport.',
    loading: 'Chargement des rapports...',
    noResults: 'Aucun rapport ne correspond aux filtres sélectionnés.',
    createPrompt: "Sélectionnez Générer un rapport pour créer un nouveau rapport d'analyse.",
    status: {
      completed: 'Terminé',
      failed: 'Échec',
      inProgress: 'En cours',
      pending: 'En attente',
    },
    rangeType: {
      monthly: 'Mensuel',
      quarterly: 'Trimestriel',
      custom: 'Personnalisé',
    },
    headers: {
      id: 'ID',
      status: 'Statut',
      type: 'Type',
      dateRange: 'Plage de dates',
      sessions: 'Sessions',
      generated: 'Généré',
      actions: 'Actions',
    },
  },
  modals: {
    close: 'Fermer',
    identifier: 'ID : {{id}}',
    generateReport: {
      title: "Générer un rapport d'analyse",
      invalidDateRange: 'Sélectionnez une plage de dates valide.',
      generationFailed: 'Impossible de générer le rapport.',
      insufficientConfirmation: "Seulement {{available}} enregistrements d'analyse sont disponibles (minimum recommandé : {{minimum}}). Voulez-vous continuer ?",
      successTitle: 'La génération du rapport a commencé avec succès.',
      successDescription: "La génération du rapport peut prendre plusieurs minutes. Vous pouvez suivre la progression dans l'onglet Rapports.",
      reportType: 'Type de rapport',
      month: 'Mois',
      year: 'Année',
      quarter: 'Trimestre',
      quarterOption: 'T{{quarter}} ({{start}}-{{end}})',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      customerId: 'ID client (facultatif)',
      allCustomers: 'Laissez vide pour tous les clients',
      checkingAvailability: "Vérification des enregistrements d'analyse disponibles...",
      availability: "{{count}} enregistrements d'analyse disponibles",
      limitedAvailability: "Seulement {{count}} enregistrements d'analyse sont disponibles (minimum recommandé : {{minimum}})",
    },
    sessionDetail: {
      title: 'Détails de la session',
      overview: 'Aperçu',
      sessionId: 'ID de session :',
      customer: 'Client :',
      user: 'Utilisateur :',
      started: 'Commencée :',
      lastActivity: 'Dernière activité :',
      totalMessages: 'Total des messages :',
      messages: 'Messages ({{count}})',
      userRole: 'Utilisateur',
      assistantRole: 'Assistant',
      fleet: 'Flotte :',
      helpful: 'Utile',
      notHelpful: 'Non utile',
      loadingMap: 'Chargement de la carte...',
      noTrace: "Aucune donnée de trace n'est disponible pour ce message.",
      traceLoadFailed: 'Impossible de charger les détails de la trace.',
      loadingTrace: 'Chargement de la trace',
    },
    feedbackDetail: {
      title: 'Détails des commentaires',
      overview: 'Aperçu',
      rating: 'Évaluation :',
      positive: 'Positif',
      negative: 'Négatif',
      submitted: 'Envoyé :',
      customer: 'Client :',
      user: 'Utilisateur :',
      sessionId: 'ID de session :',
      message: 'Message',
      comments: 'Commentaires',
      viewRelatedSession: 'Voir la session associée',
      noSession: "Aucun ID de session n'est associé à ce commentaire.",
      sessionLoadFailed: 'Impossible de charger les détails de la session.',
    },
    linkClicks: {
      title: 'Clics sur les liens ({{count}})',
      loadFailed: 'Impossible de charger les clics sur les liens.',
      loading: 'Chargement des clics sur les liens...',
      noResults: "Aucun clic sur un lien n'a été enregistré pour cette session.",
      headers: {
        userEmail: "Adresse courriel de l'utilisateur",
        url: 'URL',
        linkText: 'Texte du lien',
        type: 'Type',
        clickedAt: 'Cliqué le',
      },
    },
    traceDetail: {
      title: 'Détails de la trace',
      overview: 'Aperçu',
      traceId: 'ID de trace :',
      model: 'Modèle :',
      customerId: 'ID client :',
      totalTime: 'Durée totale :',
      inputTokens: "Jetons d'entrée :",
      outputTokens: 'Jetons de sortie :',
      cacheRead: 'Lecture du cache :',
      stopReason: "Motif d'arrêt :",
      message: 'Message',
      events: 'Événements ({{count}})',
      tool: 'Outil :',
      useId: "ID d'utilisation :",
      inputParameters: "Paramètres d'entrée",
      output: 'Résultat',
      intent: 'Intention :',
      intentScore: "Score d'intention :",
      contextMessagesUsed: 'Messages de contexte utilisés :',
      contextMessagesRendered: 'Messages de contexte affichés :',
      contextMessageIds: 'ID des messages de contexte ({{count}})',
      systemPrompt: 'Prompt système',
      metadata: 'Métadonnées',
      reasoning: 'Raisonnement :',
      toolExecutions: "Exécutions d'outils ({{count}})",
      success: 'Succès',
      failed: 'Échec',
      sessionDocuments: 'Documents de session ({{count}})',
      sessionDocument: 'Document de session',
      mapSessionDocument: 'Document de session cartographique',
      documentSessionDocument: 'Document de session',
      type: 'Type :',
      summary: 'Résumé :',
      documentId: 'ID du document :',
      toolUseId: "ID d'utilisation de l'outil :",
      created: 'Créé le :',
      data: 'Données',
      truncated: 'tronquées',
    },
    sessionAnalysis: {
      title: 'Analyse de la session',
      overview: "Aperçu de l'analyse",
      overallScore: 'Score global',
      clarityScore: 'Score de clarté',
      actionabilityScore: "Score d'applicabilité",
      responseQualityScore: 'Score de qualité de la réponse',
      details: "Détails de l'analyse",
      intentSummary: "Résumé de l'intention :",
      isFailure: "Est un échec :",
      yes: 'Oui',
      no: 'Non',
      validationStatus: 'Statut de validation :',
      modelId: 'ID du modèle :',
      analysisVersion: "Version de l'analyse :",
      analysisTime: "Heure de l'analyse :",
      validationMessages: 'Messages de validation',
      fullJson: "JSON complet de l'analyse",
      noJson: "Aucun JSON d'analyse disponible",
    },
    toolOutput: {
      title: "Résultat de l'outil : {{name}}",
      sessionDocumentTitle: 'Données du document de session : {{title}}',
      copyData: 'Copier les données dans le presse-papiers',
      copyOutput: 'Copier le résultat dans le presse-papiers',
      loadingData: 'Chargement des données...',
      loadingOutput: 'Chargement du résultat...',
      noData: 'Aucune donnée disponible',
      noOutput: 'Aucun résultat disponible',
      sessionDocumentDataRequired: 'Un ID de session est requis pour récupérer les données du document de session.',
      outputRequired: 'Un ID de session est requis pour récupérer le résultat.',
      dataLoadFailed: 'Impossible de charger les données du document de session.',
      outputLoadFailed: 'Impossible de charger le résultat.',
    },
  },
  pagination: {
    summary: 'Affichage de {{start}} à {{end}} sur {{total}} résultats',
    detailedSummary: 'Affichage de {{start}} à {{end}} sur {{total}} résultats (page {{currentPage}} sur {{totalPages}})',
    pageSummary: 'Page {{currentPage}} sur {{totalPages}}',
    previousPage: 'Page précédente',
    nextPage: 'Page suivante',
  },
} as const;

export default admin;